import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-99a23386"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.executeButton(_ctx.command))),
    type: "button"
  }, [
    _createElementVNode("img", {
      src: _ctx.iconSRC,
      alt: "아이콘"
    }, null, 8, _hoisted_1),
    _createElementVNode("span", null, _toDisplayString(_ctx.text), 1)
  ]))
}